import { AgeRange } from '../enums';

import * as child from './child-questions-data';
import * as junior from './junior-questions-data';
import * as teenager from './teenager-questions-data';
import * as adult from './adult-questions-data';

export const Questions = {
    [AgeRange.Child]: child.questionData,
    [AgeRange.Junior]: junior.questionData,
    [AgeRange.Teenager]: teenager.questionData,
    [AgeRange.Adult]: adult.questionData,
}